export default __webpack_public_path__ + "static/lframe-brokers-a0130bd0335f45d579e7b2e6da9f22a7.png";